module.exports = __webpack_public_path__ + "static/media/Brennan_Lodge.3f36b278.png";